<template>
  <div>
    <div class="routine-list">
      <products-item
        v-for="(item, index) in items"
        :key="index"
        :item="item"
        :message="message"
        @product-clicked="$emit('product-clicked', $event)"
        @product-added-to-cart="$emit('product-added-to-cart', $event)"
        @attribute-matching-list-expanded="$emit('attribute-matching-list-expanded', $event)"
        @product-info-clicked="$emit('product-info-clicked', $event)"
      />
    </div>
    <div :class="routineListActionClasses">
      <button
        v-if="showAddRoutineToCartButton"
        type="button"
        class="add-routine-to-cart-button"
        @click="addRoutineToCart"
      >
        <add-to-cart-icon class="add-routine-to-cart-button__icon" />
        <span class="add-routine-to-cart-button__text">
          {{ $t('product.addRoutineToCart') }}
        </span>
      </button>
      <div v-if="isShowingCheckOrSpinnerIcons" class="routine-list__actions__feedback">
        <add-to-cart-check v-if="isShowingCheckIcon" />
        <add-to-cart-spinner v-if="isShowingSpinnerIcon" />
      </div>
    </div>
  </div>
</template>

<script>
// @flow
import { mapGetters, mapState } from 'vuex'

import { ChatchampMessageItem } from '@chatchamp/chatchamp-types'

import ProductsItem from '../ProductsItem/ProductsItem.vue'
import AddToCartIcon from '../ProductsItem/AddToCartButton/AddToCartIcon.vue'
import AddToCartCheck from '../ProductsItem/AddToCartButton/AddToCartCheck.vue'
import AddToCartSpinner from '../ProductsItem/AddToCartButton/AddToCartSpinner.vue'

export default {
  components: {
    ProductsItem,
    AddToCartIcon,
    AddToCartSpinner,
    AddToCartCheck
  },
  props: {
    message: {
      type: Object,
      default: () => {
      }
    }
  },
  computed: {
    ...mapGetters(['isEnabledAddToCart']),
    ...mapState(['customerId', 'routineAddingToCart', 'cartProducts']),
    items (): Array<ChatchampMessageItem> {
      return this.message.content.elements
    },
    routineProductIds (): Array<string> {
      return this.items.map(item => item.productIdentifier)
    },
    showAddRoutineToCartButton (): boolean {
      return this.isEnabledAddToCart && this.message.content.isAddRoutineToCartEnabled
    },
    routineListActionClasses (): Object {
      return {
        'routine-list__actions': true,
        'routine-list__actions--is-disabled': this.isShowingCheckOrSpinnerIcons
      }
    },
    isShowingCheckOrSpinnerIcons (): boolean {
      return this.isShowingCheckIcon || this.isShowingSpinnerIcon
    },
    isShowingCheckIcon (): boolean {
      return this.routineProductIds.every(productId => this.cartProducts.includes(productId))
    },
    isShowingSpinnerIcon (): boolean {
      return this.routineAddingToCart
    }
  },
  methods: {
    addRoutineToCart (): void {
      this.$emit('product-routine-added-to-cart', {
        products: this.items,
        productIds: this.routineProductIds,
        chatbotId: this.message.content.chatbotId
      })
    }
  }
}
</script>

<style src="./routine-list.scss" />
